import React from 'react';
import { withRouter } from 'react-router-dom';
import NHTable from '../../components/common/NHTable';
import getSize from '../../utils/getSize';
import css from './index.css';
import createHistory from 'history/createHashHistory';

import createHashHistory from 'history/createHashHistory';
const hashHistory = createHashHistory();
const history = createHistory();
class TableIndex extends React.Component {
  constructor(props) {
    super(props);
  }

  handleView = (record) => { 
    window.open("#/show/"+record.PKID+"/YXXT_DPXS_SCHOOL_FLC"); 
  };

  render() {
    //列参数
    const columns = [
      {
        title: '序号',
        width: '60px',
        dataIndex: 'ROW_ID',
      },
      {
        title: '年度',
        width: '60px',
        dataIndex: 'ND',
        searchType: 'input',
      },
      {
        title: '流程名称',
        width: '150px',
        dataIndex: 'LCMC',
        search: 'input',
        searchType: 'input',
      },
      {
        title: '包含环节',
        width: '200px',
        dataIndex: 'HJMC',
        searchType: 'input',
      },
      {
        title: '已分配学生数',
        width: '120px',
        dataIndex: 'YFPXSS',
        searchType: 'input',
      },
    ];

    //行内操作
    const action = [
      {
        title: '查看',
        onClick: this.handleView,
      },
    ];

    return (
      <div
        className={css.main_right_content}
        style={{ height: getSize().windowH - 123 }}
      >
        <div className={css.table} style={{ height: getSize().windowH - 123 }}>
          <NHTable
            ref="nhTable"
            rowKey={(record) => record.PKID}
            sign={'zhxg_yxxt_lcgl_lcpz_dp'}
            columns={columns}
            action={action} 
          ></NHTable>
        </div>
      </div>
    );
  }
}
export default withRouter(TableIndex);



// WEBPACK FOOTER //
// ./containers/Show/tableIndex.js